<template>
  <div class="footer">
    <div class="footer-inner">
      <div class="footer-left">
        Copyright © 2020 - 2025 <a href="https://www.bqrdh.com" target="_blank">不求人导航</a>  <a href="https://beian.miit.gov.cn/" target="_blank">闽ICP备19026837号</a>
      </div>
      <div class="footer-right">
        <i class="fa fa-at"></i> <a href="https://shop.bqrdh.com" target="_blank">阿里内购网</a>  <i class="fa fa-at"></i><a href="https://jd.bqrdh.com" target="_blank">京内购</a>
      </div>

    </div>
  </div>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped lang="less">
    .footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 35px;
      line-height: 35px;
      color: #888;
      font-size: 13px;

      &-inner {
        width: 470px;
        margin: 0 auto;
      }

      &-left {
        float: left;
      }

      &-right {
        float: right;
      }
    }
</style>



// WEBPACK FOOTER //
// index.vue?550bfb45